document.addEventListener('DOMContentLoaded', function () {

  // MRP in Card Section
  setInterval(function () {
    // let pr = document.querySelector('.product-recommendations')
    // if (pr) { pr.style.border = '1px solid red'; }

    let gridViewItem = document.querySelectorAll('.grid-view-item');

    if (gridViewItem.length > 0) {

      gridViewItem.forEach((i) => {
        let saleHidden = i.querySelector('.product-price--sale.hidden');
        let mrp = i.querySelector('.product-price--regular .money');

        // i.style.border = '1px solid red';
        if (saleHidden) {
          mrp.classList.add('mrp');
        }
      })
    }

  }, 100);

  // MRP in Product Page
  let comparePrice = document.querySelector('.product-section .product-form-block .product-price-group .compare-at-price')
  let productPrice = document.querySelector('.product-section .product-form-block .product-price-group #ProductPrice .money')

  if (productPrice) {
    if (!comparePrice) {
      productPrice.classList.add('mrp');
    }
  }
})